export const createQueryParams = (params) => {
    return Object.keys(params)
        .reduce((acc, k) => {
        if (params[k] !== undefined) {
            acc.push(`${k}=${encodeURI(params[k])}`);
        }
        return acc;
    }, [])
        .join('&');
};
//# sourceMappingURL=createQueryParams.js.map